<template>
  <div>{{ data }}</div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'TextComponent',
    props: {
      data: String,
    }
})
</script>